import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ServerAction } from '@cbridge-packages/server';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeServerBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { serverId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    // ids come as string or number depending on the source (route param, grid row id, store)
    if (openedDetailsId !== undefined && String(openedDetailsId) === String(serverId)) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
